import { render } from "./confirm_modal.vue?vue&type=template&id=52a9bed6&scoped=true"
import script from "./confirm_modal.js?vue&type=script&lang=js"
export * from "./confirm_modal.js?vue&type=script&lang=js"

import "./confirm_modal.vue?vue&type=style&index=0&id=52a9bed6&lang=scss&scoped=true"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a9bed6"]])

export default __exports__